<template lang="pug">
.card.c-hand(@click="debito.selected = !debito.selected")
  .card-body
    .columns.align-items-center
      .column
        text-output(label="Descrição", :text="debito.descricao")
      .col-auto
        .form-group
          .form-switch
            input(type="checkbox", v-model="debito.selected")
            i.form-icon
    .columns
      .column
        text-output(label="Parcela", :text="`${debito.parcela}/${debito.ano}`")
      .column.col-auto.text-error
        text-output(label="Valor", :text="debito.valor | currency('R$')")
    .text-gray.text-small {{ debito.vence_em | date("dd/MM/YYYY") }}
</template>

<script>
export default {
  props: { debito: { type: Object, required: true } },
};
</script>
